import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getMeetingsList, getBrokerToursList, selectMeetingsList, selectBrokerToursList, closeRatingPopup, closeErrorMsg, resetStore } from "../../redux/modules/meeting";
import Layout from "../layout"
import Loader from "../common/loader"
import Table from "../common/table"
import Filter from './filter';
import PopupRate from './popup-rate';
import PopupRemove from './popup-remove'
import PopupMsg from '../common/popup-msg'

const Page = ({eventTypeId}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [active, setActive] = useState(location.state ? decodeURI(location.state.hash) : (window.location.hash ? decodeURI(window.location.hash.split('#')[1]) : eventTypeId == 1 ? 'Запланирована' : 'Запланирован'));
//console.log(location)
//console.log(decodeURI(window.location.hash.split('#')[1]))
  const [fields, setValue] = useState({
    dateStart: {value:''},
    dateEnd: {value:''},
    manager: {value:''},
    clientName: {value:''},
    project: {value:''},
    type: {value:''},
    search: {value:''},
    brocker: {value:''},
    rated: {value: true}
  });  
  const [items, setItems] = useState(null);

  const auth = useSelector(state => state.auth);
  const meeting = useSelector(state => state.meeting);
  const meetings = useSelector(state => state.meeting.response);
  const brokertours = useSelector(state => state.meeting.brokertours);
  const mobile = useSelector(state => state.mobile);

  const result = useSelector(state => eventTypeId == 1 ? selectMeetingsList(state) : selectBrokerToursList(state));

  const scrolled = () => {
    const width = window.innerWidth
    const scrollTop = width < 1000 ? document.querySelector('.page__content').scrollTop : document.querySelector('.tabs-content').scrollTop;
    const height =  width < 1000  ?  (document.querySelector('.visible').offsetTop + document.querySelector('.visible').offsetHeight - 48) : document.querySelector('.visible').offsetHeight;

    if (scrollTop > height ) {
      if(width < 1000) {
        document.querySelector('.table__head').classList.add('fixed');
        document.querySelector('.filter-btn').classList.add('visible');
      } else {
        setVisible(false);
      }
    } else {
      if(width < 1000) {
        document.querySelector('.table__head').classList.remove('fixed');
        document.querySelector('.filter-btn').classList.remove('visible');
      } else {
        setVisible(true);
      }    
    }
  };


  useEffect(() => {
    if(eventTypeId == 1) {
      dispatch(
        getMeetingsList({
          cmd: 'orders-list',
          eventTypeId: eventTypeId,
          _debug_token: auth.token
        })
      )
    }
    if(eventTypeId == 2) {
      dispatch(
        getBrokerToursList({
          cmd: 'orders-list',
          eventTypeId: eventTypeId,
          _debug_token: auth.token
        })
      )
    }
    
    document.querySelector('.page__content').addEventListener('scroll', scrolled);
    document.querySelector('.tabs-content').addEventListener('scroll', scrolled);    
    
    return () => {      
      if(document.querySelector('.page__content') && document.querySelector('.page__content').length) document.querySelector('.page__content').removeEventListener('scroll', scrolled);
      if(document.querySelector('.tabs-content') && document.querySelector('.tabs-content').length) document.querySelector('.tabs-content').removeEventListener('scroll', scrolled);
      dispatch(resetStore())
    }

  }, []);

  useEffect(() => {    
    
    dispatch(closeRatingPopup())
    if(eventTypeId == 1 && !meetings) {
      dispatch(
        getMeetingsList({
          cmd: 'orders-list',
          eventTypeId: eventTypeId,
          _debug_token: auth.token
        })
      )
    }
    if(eventTypeId == 2 && !brokertours) {
      dispatch(
        getBrokerToursList({
          cmd: 'orders-list',
          eventTypeId: eventTypeId,
          _debug_token: auth.token
        })
      )
    }

  }, [meeting.rated]);

  const handleClick = (status) => {
    setActive(status);  
    navigate('#' + status);
  };

  const handleFilterClick = () => {
    setVisible(!visible);
    document.querySelector('.tabs-content').scrollTo(0, 0) 
  };

  const handleRate = (e, value) => {
    const index = parseInt(e.target.id, 0);
    if (index !== active) {
      setActive(index);
      setValue({ ...fields, ['status']: { value: !fields.status.value ? (eventTypeId == 1 ? 'Выполнена' : 'Выполнен') : '' }, ['rated']: { value: !fields.rated.value } })
    }    
  };

  const countItemsByStatus = (data, status) => {
    if (!data) return 0;
    return data.filter((item) => item.status === status).length;
  };

  const counts = {
    all: result ? result.length : 0,
    scheduled: countItemsByStatus(result, eventTypeId == 1 ? 'Запланирована' : 'Запланирован'),
    finish: countItemsByStatus(result, eventTypeId == 1 ? 'Выполнена' : 'Выполнен'),
    cancel: countItemsByStatus(result, eventTypeId == 1 ? 'Отменена' : 'Отменен'),
  };

  const filteredResult = items ? items.filter((item) => active === "Все" || item.status === active) : result && !fields.dateStart.value && !fields.dateEnd.value ? result.filter((item) => active === "Все" || item.status === active) : [];

  return (
    <Layout>
      {meeting.loading && <Loader />}
      <div className="meeting-page">
        <div className="tabs">
          <div className="tabs__wrap">
            <div className="tabs__item" onClick={() => handleClick("Все")} data-active={active === "Все"} id={"Все"}>
              Все
              {!mobile && counts.all > 0 && <div className="tabs__label">{counts.all}</div>}
            </div>
            <div className="tabs__item" onClick={() => handleClick(eventTypeId == 1 ? 'Запланирована' : 'Запланирован')} data-active={active === 'Запланирована' || active === 'Запланирован'} id={eventTypeId == 1 ? 'Запланирована' : 'Запланирован'}>
              {mobile ? 'будущие' : 'Запланированные'}
              {!mobile && counts.scheduled > 0 && <div className="tabs__label">{counts.scheduled}</div>}
            </div>
            <div className="tabs__item" onClick={() => handleClick(eventTypeId == 1 ? 'Выполнена' : 'Выполнен')} data-active={active === 'Выполнена' || active === 'Выполнен'} id={eventTypeId == 1 ? 'Выполнена' : 'Выполнен'}>
              {mobile ? 'Завершены' : 'Завершенные'}
              {!mobile && counts.finish > 0 && <div className="tabs__label">{counts.finish}</div>}
            </div>
            <div className="tabs__item" onClick={() => handleClick(eventTypeId == 1 ? 'Отменена' : 'Отменен' )} data-active={active === 'Отменена' || active === 'Отменен'} id={eventTypeId == 1 ? 'Отменена' : 'Отменен'}>              
              {mobile ? 'Отменены' : 'Отмененные'}
              {!mobile && counts.cancel > 0 && <div className="tabs__label">{counts.cancel}</div>}
            </div>
          </div>
          {/*!mobile && <Link to={eventTypeId == 1 ? "/regist-meeting" : "/regist-broker-tour"} className="btn">{eventTypeId == 1 ? "Добавить встречу" : "Добавить брокер-тур"}</Link>*/}
          {!visible && <div className="filter-btn" onClick={handleFilterClick}></div>}
        </div>
      
        <div className="tabs-content">
          {/*<div className="meeting-marks">
            <div className="marks-info">
              <span></span>Оцените, пожалуйста, завершенные {eventTypeId == 1 ? 'встречи' : 'брокер-туры'} - {result && result.filter((item) => item.status === "Выполнена" && item.rate == undefined).length}
            </div>
            <div className={fields.rated.value ? "marks-switch" : "marks-switch marks-switch_active"} onClick={handleRate}>
              Встречи без оценок
            </div>
          </div>*/}
          <div className={visible ? "visible" : "visible visible_hide"}>
            <Filter fields={fields} setValue={setValue}  alldata={result} setItems={setItems} data={filteredResult} eventTypeId={eventTypeId} />
          </div> 
          {mobile && <div className="filter-btn" onClick={() => document.querySelector('.page__content').scrollTo(0, 0) }></div>}        
          <Table 
            columns={mobile ? (
              auth.user.group === "lead" ? 
                eventTypeId == 1 ? [
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "", value: "action" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
                { label: "Брокер", value: "brocker" },
              ] : [
                { label: "Дата и время", value: "timeslot" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "", value: "action" },
                { label: "Формат брокер-тура", value: "formatId" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Брокер", value: "brocker" },
              ] : eventTypeId == 1 ? [
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "", value: "action" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
              ] : [
                { label: "Дата и время", value: "timeslot" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "", value: "action" },
                { label: "Формат брокер-тура", value: "formatId" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
              ]
            ) : (
              auth.user.group === "lead" ? 
                eventTypeId == 1 ? [
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
                { label: "Брокер", value: "brocker" },
                { label: "Действия", value: "action" },
              ] : [
                { label: "Дата и время", value: "timeslot" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат брокер-тура", value: "formatId" },
                { label: "Брокер", value: "brocker" },
                { label: "Действия", value: "action" },
              ] : eventTypeId == 1 ? [
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
                { label: "Действия", value: "action" },
              ] : [
                { label: "Дата и время", value: "timeslot" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат брокер-тура", value: "formatId" },
                { label: "Действия", value: "action" },
              ]
            )}
            sortmobile={eventTypeId == 1 ? [
              { label: "Дата/время", value: "timeslot" },
              { label: "Клиент", value: "clientName" },
            ] : [
              { label: "Дата/время", value: "timeslot" },
              { label: "Проект", value: "project" },
            ]}
            eventTypeId={eventTypeId}
            data={filteredResult}
          /> 
        </div>
        {meeting.rate && !meeting.rated && <PopupRate eventTypeId={eventTypeId} close={() => dispatch(closeRatingPopup())} />}
        {/*meeting.cancel &&  <PopupRemove data={meeting.cancel} />*/}
      </div>      
      {meeting.error && <PopupMsg message={meeting.error} close={closeErrorMsg()} />}
    </Layout>
  )
}

export default Page